import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Account: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M27 16a11 11 0 1 0-19.04 7.5 10.97 10.97 0 0 1 16.08 0A10.96 10.96 0 0 0 27 16Zm-11 6a8.97 8.97 0 0 0-6.56 2.83 10.95 10.95 0 0 0 13.11 0A8.97 8.97 0 0 0 16 22Zm3-9a3 3 0 1 0-6 0 3 3 0 0 0 6 0Zm10 3a12.97 12.97 0 0 1-13 13A12.97 12.97 0 0 1 3 16a13 13 0 0 1 26 0Zm-8-3a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
    />
  </Icon>
);
